<template>
  <div class="max-w-[2560px] mx-auto">
    <div>
      <navigation-bar></navigation-bar>
    </div>
    <div>
      <header-component
        :img="headerData.currentImage"
        :title="getLocalized(headerData, 'title')"
        :detailed="getLocalized(headerData, 'description')"
        :is-upper="true"
        :is-visible="true"
      ></header-component>
    </div>
    <!-- Benefit Card -->
    <div>
      <benifit-card></benifit-card>
    </div>
    <div>
      <div>
        <service-card></service-card>
      </div>

      <!-- Our Partner -->
      <div>
        <ourPartner></ourPartner>
      </div>

      <!-- Client Say About Us -->
      <div>
        <clientSayAboutUsVue></clientSayAboutUsVue>
      </div>

      <!-- Download App -->
      <div>
        <download-mobile></download-mobile>
      </div>

      <!-- FAQ -->
      <div>
        <faq-part></faq-part>
      </div>

      <!-- Contact Us -->
      <contactUs></contactUs>
      <!-- Footer -->
      <div>
        <footer-view></footer-view>
      </div>
      <!-- Button to Scroll to Top -->
      <button
        v-show="showScrollToTopButton"
        @click="scrollToTop"
        class="fixed bottom-10 right-8 bg-tbt-red text-white w-16 h-16 rounded-full shadow-lg transition-transform duration-300 hover:scale-110 focus:outline-none flex items-center justify-center z-50"
      >
        ↑
      </button>
    </div>
  </div>
</template>

<script>
import NavigationBar from "./NavigationBar.vue";
import BenifitCard from "../components/Home/benefitCard.vue";
import ourPartner from "@/components/Home/ourPartner.vue";
import downloadMobile from "@/components/Home/downloadMobile.vue";
import FaqPart from "../components/Home/faqPart.vue";
import contactUs from "@/view/contactUsComponent.vue";
import FooterView from "./footerView.vue";
import serviceCard from "@/components/Home/serviceCard.vue";
import HeaderComponent from "@/view/HeaderComponent.vue";
import { useLocalization } from "@/composable/useLocalization";
import axios from "axios";

export default {
  name: "App",
  components: {
    NavigationBar,
    BenifitCard,
    serviceCard,
    ourPartner,
    downloadMobile,
    FaqPart,
    contactUs,
    FooterView,
    HeaderComponent,
  },
  data() {
    return {
      showScrollToTopButton: false,
      headerData: {},
      api: process.env.VUE_APP_API_KEY,
    };
  },
  computed: {
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.mainServiceHeader();

    // Add screen size change listener
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    mediaQuery.addEventListener("change", this.updateResponsiveImage);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);

    // Clean up screen size change listener
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    mediaQuery.removeEventListener("change", this.updateResponsiveImage);
  },
  methods: {
    handleScroll() {
      this.showScrollToTopButton = window.scrollY > 300;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    async mainServiceHeader() {
      try {
        const response = await axios.get(`${this.api}/api/sliders`);
        const items = response.data.items.map((item) => ({
          ...item,
          image_path: `${this.api}${item.image_path}`,
          mobile_image_path: `${this.api}${item.mobile_image_path}`,
        }));
        const headerItem = items.find((item) => item.id === 1);

        if (headerItem) {
          this.headerData = {
            ...headerItem,
            currentImage: this.getResponsiveImage(headerItem),
          };
        }
      } catch (e) {
        console.error(e);
      }
    },
    getResponsiveImage(item) {
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      return isMobile ? item.mobile_image_path : item.image_path;
    },
    updateResponsiveImage() {
      if (this.headerData) {
        this.headerData.currentImage = this.getResponsiveImage(this.headerData);
      }
    },
  },
};
</script>

<style>
.scrollbar-hidden::-webkit-scrollbar {
  display: none;
}
.scrollbar-hidden {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
